<template>
  <section-page
    :is-short="true"
    class="is-danger"
    title="Lead Bulk Delete"
    description="You are allowed to do bulk delete lead by status. When deleting a lead all associated data will be deleted and will not be recoverable."
  >
    <form-field-select-status
      label="Status"
      v-model="statusId"
      include-no-status
    ></form-field-select-status>

    <button-outlined
      color="is-danger"
      :loading="isLoading"
      @click="bulkDelete"
    >
      Delete Leads
    </button-outlined>
  </section-page>
</template>

<script>
export default {
  name: "LeadBulkDelete",
  data() {
    return {
      statusId: null,
      isLoading: false,
    }
  },
  computed: {
    statuses() {
      return this.$store.getters['pipeline/statuses'];
    },
  },
  methods: {
    bulkDelete() {
      const status = this.statuses.find(status => status.id === this.statusId);

      if (! status) return;

      this.$utils.confirm(
        `Are you sure you want to <strong>delete</strong> leads in <strong>${status.label}</strong>? All associated data will be deleted and will not be recoverable.`,
        'Delete Leads'
      )
      .then(() => {
        this.isLoading = true;
        this.$api.records.bulkDelete({status_id: this.statusId})
          .then((res) => {
            this.statusId = null
            this.$buefy.toast.open({
              message: res.data.message,
              type: 'is-success',
              duration: 2000
            })
          })
          .finally(() => this.isLoading = false);
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.section_header--description {
    color: $danger;
}

.section_header {
  &--description {
    color: $danger;
  }
}
</style>
